export default "__VITE_ASSET__d017e84f__"